export const MODAL_CONFIRM_LAYOUT_CONTENT = {
    CANCEL_BUTTON: "Anuluj",
    OK_BUTTON: "Potwierdzam"
} as const;
export const MODAL_CONFIRM_LAYOUT_CONTENT = {
    CANCEL_BUTTON: "Anuluj",
    OK_BUTTON: "Potwierdzam"
} as const;
